import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  includePrivateUnits: 0,
  
}
export const systemSettingsSlice = createSlice({
  name: 'systemSettings',
  initialState: initialState,
  reducers: {
    
    setAllValues: (state, action) => {
      // Instead of state = action.payload, we need to update each property
      const newState = {
        ...state,
        includePrivateUnits: action.payload.includePrivateUnits,
       
      };
      
      
      return newState;

    }


  }
});

export const {
  setAllValues
} = systemSettingsSlice.actions;



export default systemSettingsSlice.reducer;
